import React from "react";
import TodayLiveAuction from "../components/TodayLiveAuction";
import TodayUpComingAuctions from "../components/TodayUpComingAuctions";

function TodayAuctions() {
  return (
    <div>
      <TodayLiveAuction />
      {/* <hr className="grey" />
      <TodayUpComingAuctions /> */}
    </div>
  );
}

export default TodayAuctions;
